import createEnum from 'scripts/lib/create_enum';
import { EndpointTypes } from 'models/endpoint';

export const NotificationSoundType = createEnum(
  'AGENT_NOTIFICATION',
  'DECLINED_SESSION_REASSIGNMENT',
  'INBOUND_MESSAGE',
  'PAYMENT_STATUS_EVENT',
  'CLICK',
  'BELL_CHIME',
  'MELODY',
  'HAPPY',
  'SOFT_BELL',
  'POP',
  'CLICKIES',
  'SOFT_DING'
);

// How notification sounds are chosen. Persisted across two fields —
// agentNotificationSound (BASIC vs NONE) and customizeChannelNotificationSounds
// (PER_CHANNEL) — but presented to the agent as a single radio selection.
export const SoundMode = Object.freeze({
  BASIC: 'basic',
  NONE: 'none',
  PER_CHANNEL: 'perChannel',
});

// Sounds available in the per-channel dropdown. Each channel's default
// (DEFAULT_CHANNEL_SOUNDS) is one of these values.
export const SHARED_SOUND_OPTIONS = Object.freeze([
  { value: NotificationSoundType.CLICK, label: 'Classic' },
  { value: NotificationSoundType.AGENT_NOTIFICATION, label: 'Basic sound' },
  { value: NotificationSoundType.BELL_CHIME, label: 'Bell chime' },
  { value: NotificationSoundType.MELODY, label: 'Melody' },
  { value: NotificationSoundType.HAPPY, label: 'Happy' },
  { value: NotificationSoundType.SOFT_BELL, label: 'Soft bell' },
  { value: NotificationSoundType.POP, label: 'Pop' },
  { value: NotificationSoundType.CLICKIES, label: 'Clickies' },
  { value: NotificationSoundType.SOFT_DING, label: 'Soft ding' },
]);

// EMAIL and VOICE channels intentionally omitted — their inbound events
// route through non-messaging paths that don't call playChannelNotificationSound.
export const DEFAULT_CHANNEL_SOUNDS = Object.freeze({
  [EndpointTypes.CHAT]: NotificationSoundType.HAPPY,
  [EndpointTypes.SMS]: NotificationSoundType.BELL_CHIME,
  [EndpointTypes.FB_MESSENGER]: NotificationSoundType.MELODY,
  [EndpointTypes.WHATSAPP]: NotificationSoundType.HAPPY,
  [EndpointTypes.INSTAGRAM_DIRECT]: NotificationSoundType.MELODY,
  [EndpointTypes.INSTAGRAM_COMMENT]: NotificationSoundType.MELODY,
  [EndpointTypes.TWITTER]: NotificationSoundType.BELL_CHIME,
  [EndpointTypes.CUSTOM_CHANNEL]: NotificationSoundType.SOFT_BELL,
});
